import {takeStudioFragment,retainStudioFragmentForStartup} from '../../net/connect-link';
export interface BrowserEnrollment {
 runId:string;pageNonce:string;portalOrigin:string;studioOrigin:string;studioUrl:string;rendererOrigin:string;expiresAtMs:number;
 policyId:string;policyGeneration:string;
 native:{presenceId:string;installationId:string;instanceId:string;port:number};
}
let enrollment:Readonly<BrowserEnrollment>|undefined;
let parentOwner:Window|undefined;
/** Pinned Chrome supplies ancestorOrigins; unsupported/foreign/nested frames deny.
 * The normal Portal owns OAuth; this check grants no account authority. */
export function privateParentCurrent(){
 try{return !!enrollment&&window.parent!==window&&window.parent===parentOwner&&location.ancestorOrigins.length===1&&location.ancestorOrigins[0]===enrollment.portalOrigin;}catch{return false;}
}
/** Private entry only, before any ordinary connection/application construction. No RPC setter. */
export function installPrivateBrowserEnrollment(value:BrowserEnrollment){
 const fragment=takeStudioFragment(location,history),connect=fragment.connect.link;
 try{
 if(enrollment||value.studioOrigin!==location.origin||value.studioUrl!==location.origin+location.pathname+location.search||value.expiresAtMs<=Date.now()||!value.runId||!/^[a-f0-9]{64}$/.test(value.pageNonce)||new URL(value.portalOrigin).origin!==value.portalOrigin||!value.portalOrigin.startsWith('https://')||value.portalOrigin===value.studioOrigin||!fragment.embedded||connect?.portalUrl!==value.portalOrigin||import.meta.env.VITE_GAMING_STUDIO_ENABLED!=='true')throw Error('private_native_enrollment');
 }catch{throw Error('private_native_enrollment');}
 parentOwner=window.parent;enrollment=Object.freeze({...value,native:Object.freeze({...value.native})});
 if(!privateParentCurrent()){enrollment=undefined;parentOwner=undefined;throw Error('private_native_enrollment');}
 retainStudioFragmentForStartup(location,fragment);
}
export const privateBrowserEnrollment=()=>enrollment;
